import React from "react";
import { RiLogoutBoxRLine } from "react-icons/ri";
import toast from "react-hot-toast";

/**
 * Logout Button Component
 * Handles admin logout with confirmation toast
 * Adapts to collapsed/expanded sidebar state
 */
const LogoutButton = ({ hoveredItem, setHoveredItem, isCollapsed }) => {
  const handleLogout = () => {
    localStorage.removeItem("adminAuthToken");
    window.location.reload();
  };

  const showLogoutToast = () => {
    toast(
      (t) => (
        <div className="flex flex-col items-center p-4 space-y-4">
          <p className="text-base font-medium">
            Are you sure you want to logout?
          </p>
          <div className="flex space-x-3">
            <button
              className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
              onClick={() => {
                handleLogout();
                toast.dismiss(t.id);
              }}
            >
              Logout
            </button>
            <button
              className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
              onClick={() => toast.dismiss(t.id)}
            >
              Cancel
            </button>
          </div>
        </div>
      ),
      {
        duration: 5000,
        position: "top-center",
      }
    );
  };

  return (
    <div className="px-3 pb-4 border-t border-white/20 pt-4">
      <div className="relative group">
        <button
          onClick={showLogoutToast}
          onMouseEnter={() => setHoveredItem("Logout")}
          onMouseLeave={() => setHoveredItem(null)}
          className={`w-full h-12 rounded-xl bg-white/10 hover:bg-red-500/20 text-white hover:text-red-300 transition-all duration-200 flex items-center ${
            isCollapsed ? "justify-center" : "justify-start px-4"
          } border border-white/30 hover:border-red-400/50 group`}
        >
          <RiLogoutBoxRLine className="text-2xl flex-shrink-0" />
          {!isCollapsed && (
            <span className="ml-3 text-sm font-medium">Logout</span>
          )}
        </button>

        {/* Logout Tooltip - Only show when collapsed */}
        {isCollapsed && (
          <div
            className={`fixed bg-gray-900 text-white text-xs px-3 py-2 rounded-lg whitespace-nowrap pointer-events-none transition-all duration-200 shadow-xl ${
              hoveredItem === "Logout" ? "opacity-100" : "opacity-0"
            }`}
            style={{
              zIndex: 99999,
              left: "92px",
              bottom: "32px",
            }}
          >
            Logout
            <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoutButton;
